/**
 * Landing page yönlendirme yardımcısı.
 * - REACT_APP_LANDING_URL tanımlıysa onu kullan (CI/staging override).
 * - Localhost ise http://localhost:3000 (Next dev server).
 * - Diğer durumda canlı landing domain'i.
 */
const PRODUCTION_LANDING = 'https://hopssoftware.com';

export function getLandingUrl() {
  const fromEnv = process.env.REACT_APP_LANDING_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, '');

  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'http://localhost:3000';
  }

  return PRODUCTION_LANDING;
}

/**
 * Çıkış sonrası landing'e tam sayfa redirect.
 * `?logout=1` flag'i landing'in storage'ı temizlemesi için bırakılır.
 * `replace` history'ye eklemez; back tuşu yetkisiz dashboard'a dönmez.
 */
export function redirectToLanding() {
  if (typeof window !== 'undefined') {
    window.location.replace(`${getLandingUrl()}/?logout=1`);
  }
}
